import { useMemo } from 'react';

import { useBoards, useInfinitePostsInBoard, useRemovePostsFromBoard } from '@/entities/board';

export function useBoardDetailData(boardId: string) {
  const { data: boards = [], isLoading: isBoardsLoading } = useBoards();
  const removePostsFromBoardMutation = useRemovePostsFromBoard();

  const {
    data,
    isLoading: isBoardPostsLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfinitePostsInBoard(boardId);

  const board = useMemo(() => boards.find((item) => item.id === boardId), [boards, boardId]);

  const posts = useMemo(() => {
    if (!data?.pages) return [];
    return data.pages.flatMap((page) => page.posts);
  }, [data]);

  return {
    board,
    posts,
    isLoading: isBoardsLoading || isBoardPostsLoading || removePostsFromBoardMutation.isPending,
    isBoardsLoading,
    isFetchingNextPage,
    hasNextPage: Boolean(hasNextPage),
    fetchNextPage,
  };
}
